<link rel="ractive" href="./request-bandwidth-stats.html" name="c-request-bandwidth-stats">

<div class="c-proxy-request-bandwidth-stats">
	<c-request-bandwidth-stats
		requestsAmount="{{requestsAmount}}"
		requestsGrowthPercent="{{requestsGrowthPercent}}"
		growthPeriod="{{growthPeriod}}"
		bandwidthAmount="{{bandwidthAmount}}"
		bandwidthUnit="{{bandwidthUnitInternal}}"
		bandwidthGrowthPercent="{{bandwidthGrowthPercent}}">
	</c-request-bandwidth-stats>
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const stats = require('../../assets/js/utils/stats');

	component.exports = {
		data () {
			return {
				_,
				requestsAmount: 0,
				bandwidthAmount: 0,
				requestsGrowthPercent: 0,
				bandwidthGrowthPercent: 0,
				growthPeriods: stats.growthPeriods,
				growthPeriod: 'monthly',
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observe('periodData', ({ periodValue, periodType }) => {
					let name = this.get('name');
					let bandwidthUnit = this.get('bandwidthUnit');

					this.set('growthPeriod', this.get('growthPeriods')[periodType]);

					http.fetchCdnOssStats(name, periodValue).then(({ hits, bandwidth }) => {
						if (hits.total >= 0) {
							this.animate('requestsAmount', hits.total, { duration: 1000 });
							this.animate('requestsGrowthPercent', _.calculateGrowth(hits.total, hits.prev.total), { duration: 1000 });
						}

						if (bandwidth.total >= 0) {
							if (!bandwidthUnit) {
								bandwidthUnit = _.findUnitFromNumber(bandwidth.total);
							}

							this.set('bandwidthUnitInternal', bandwidthUnit);
							this.animate('bandwidthAmount', _.convertBytesToUnits(bandwidth.total, bandwidthUnit), { duration: 1000 });
							this.animate('bandwidthGrowthPercent', _.calculateGrowth(bandwidth.total, bandwidth.prev.total), { duration: 1000 });
						}
					});
				});
			}
		},
	};
</script>
